module.exports = __webpack_public_path__ + "static/media/logo.8343370c.webp";